var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('img',{staticStyle:{"width":"100vw","min-height":"100vh"},attrs:{"src":require("../../assets/hscs/报名点/宝山区报名地点.png"),"alt":""}})])}]

export { render, staticRenderFns }